export default __webpack_public_path__ + "static/media/pc.b0d91d41.png";